// extracted by mini-css-extract-plugin
export default {"root":"UndefinedFile_root__zl+PO","placeHolderShimmer":"UndefinedFile_placeHolderShimmer__4xXNu"};